<template>
  <div class="linebar-container">
    <div :class="'linebar1 ' + themeColor"></div>
    <div :class="'linebar2 ' + themeColor"></div>
    <div :class="'linebar3 ' + themeColor"></div>
    <div :class="'linebar4 ' + themeColor"></div>
    <div :class="'linebar-title ' + themeColor + '--text'">
      POLLS
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    themeColor() {
      return this.$store.state.event.theme
        .replace(/([a-zA-Z])(?=[A-Z])/g, "$1-")
        .toLowerCase();
    }
  }
};
</script>
<style>
/**draw poll icon */

.linebar-container {
  width: 70px;
  margin: 10px auto;
}
.linebar1 {
  position: absolute;
  width: 15px;
  height: 80px;
  background: #555;
  border-radius: 3px;
  /*box-shadow: 2px 2px 10px #666;*/
}
.linebar2 {
  position: absolute;
  margin-left: 20px;
  margin-top: 20px;
  width: 15px;
  height: 60px;
  background: #555;
  border-radius: 3px;
  /*box-shadow: 2px 2px 10px #666;*/
}
.linebar3 {
  position: absolute;
  margin-left: 40px;
  margin-top: 50px;
  width: 15px;
  height: 30px;
  background: #555;
  border-radius: 3px;
  /*box-shadow: 2px 2px 10px #666;*/
}
.linebar4 {
  position: absolute;
  margin-left: 60px;
  margin-top: 35px;
  width: 15px;
  height: 45px;
  background: #555;
  border-radius: 3px;
  /*box-shadow: 2px 2px 10px #666;*/
}
.linebar-title {
  position: absolute;
  margin-top: 83px;
  margin-left: 12px;

  font-size: 18px;
}
</style>
